export const TipsDistributionBulkRoutes = [
    {
        "url": "/tips-distribution",
        "name": "appLayout.harriSH.tips-distribution",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {},
        "component": "tipsDistributionPageContainer",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: []
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/tips-distribution/tips-distribution-bulk/tips-distribution-bulk.downgrade.module");
                }
            },
        ],
    }
];
//# sourceMappingURL=tips-distribution-bulk.routes.js.map